import React, { useState } from "react";
import {faqs} from '../../../assets/data/homeData'

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="py-16 bg-btn-secondary-base bg-opacity-30">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-10 text-btn-primary">Frequently Asked Questions</h2>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="border border-btn-secondary rounded-lg bg-white">
              <button
                className="w-full text-left px-6 py-4 font-semibold focus:outline-none flex justify-between items-center text-btn-primary"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                {faq.question}
                <span className="text-btn-secondary">{openIdx === idx ? "-" : "+"}</span>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-4 text-black">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
